import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import { CircularProgress, ListItem, Tooltip } from "@mui/material";
import PostAddIcon from "@mui/icons-material/PostAdd";
import {
  fetchRiskManagementPlanDetails,
  deleteRiskManagementPlan,
  downloadRiskManagementPlan,
  updateRiskManagementPlan,
} from "../helper";
import RichTextBoxTabPanel from "../../../components/RichTextBoxEditerTabs";
import {
  EditPlan,
  PlanImport,
  DeletePlan,
} from "../../../assets/RiskManagementIcon";
import { useUserContext } from "../../../context/auth/UserContext";
import { useRiskManagementContext } from "../../../context/RiskManagement/RiskManagementContext";
import { useAccessRights } from "../../../utils/useAccessRights";
import { getUserName } from "../../../helper/helper";

export const DisplayRiskManagementPlanDetails = (props: {
  loadingPage: boolean;
  refreshList: () => void;
}) => {
  const navigate = useNavigate();
  const riskManagementPageAccess = useAccessRights("Risk Management - CS & SC");

  const [isLoadingPlanDetails, setIsLoadingPlanDetails] =
    useState<boolean>(false);
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });

  const { userId, companyProfileID } = useUserContext();
  const {
    tabValue,
    selectedRiskManagement,
    setSelectedRiskManagement,
    planDetails,
    setPlanDetails,
  } = useRiskManagementContext();
  const tabDetalis = [
    {
      label: "overview",
      key: "overview",
      id: "tab-overview",
      editerValue: planDetails?.overview ? planDetails.overview : "",
    },
    {
      label: "purpose",
      key: "purpose",
      id: "tab-purpose",
      editerValue: planDetails?.purpose ? planDetails.purpose : "",
    },
    {
      label: "scope",
      key: "scope",
      id: "tab-scope",
      editerValue: planDetails?.scope ? planDetails.scope : "",
    },
    {
      label: "definition",
      key: "definition",
      id: "tab-definition",
      editerValue: planDetails?.definition ? planDetails.definition : "",
    },
    {
      label: "plan",
      key: "plan",
      id: "tab-plan",
      editerValue: planDetails?.plan ? planDetails.plan : "",
    },
    {
      label: "compliance",
      key: "compliance",
      id: "tab-compliance",
      editerValue: planDetails?.compliance ? planDetails.compliance : "",
    },
    {
      label: "Related Documents",
      key: "relatedPolicies",
      id: "tab-relatedPolicies",
      editerValue: planDetails?.relatedPolicies
        ? planDetails.relatedPolicies
        : "",
    },
  ];

  const isPlanSelected = () => {
    return (
      selectedRiskManagement?.csRiskManagementPlanID ||
      selectedRiskManagement?.supplyChainPlanID
    );
  };

  const displayRiskManagementForm = (action: string) => {
    if (action === "add") {
      setPlanDetails({});
    }
    navigate("/risk-management-form", { state: { action } });
  };

  const handleDialogClose = () => {
    setDialogState({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    });
    if (dialogState.title === "Success") {
      props.refreshList();
    }
  };

  const displayEditForm = async (details: any) => {
    const date = new Date();
    const payload = {
      ...details,
      isEditedByUser: true,
      isEditedByUserId: userId + "",
      updateBy: userId,
      updateDate: date,
    };

    const resUpdate = await updateRiskManagementPlan(
      tabValue === 0 ? "cyberSecurity" : "supplyChain",
      payload
    );
    if (resUpdate.succeeded === true) {
      navigate("/risk-management-form", { state: { action: "edit" } });
    }
  };

  const handleEditRiskManagement = async () => {
    console.log("handleEditPolicy plan");

    const res = await fetchRiskManagementPlanDetails(
      tabValue === 0 ? "cyberSecurity" : "supplyChain",
      tabValue === 0
        ? selectedRiskManagement?.csRiskManagementPlanID
        : selectedRiskManagement?.supplyChainPlanID
    );
    console.log("handleEditPolicy plan", res);
    if (res.isEditedByUser && parseInt(res.isEditedByUserId) !== userId) {
      let userName = await getUserName(res.isEditedByUserId);
      setDialogState({
        title: "Info",
        body: `You are unable to modify this plan because ${userName} has already begun editing it.`,
        action: "Ok",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      displayEditForm(res);
    }
  };

  const confirmDelete = () => {
    setDialogState({
      title: "Confirmation",
      body: `Are you sure you want to delete this plan?`,
      action: "Delete",
      actionCancel: "Cancel",
      openDeleteConfirmationDialog: true,
      openSuccessDialogBox: false,
    });
  };

  const handleDeletePlan = async () => {
    setSelectedRiskManagement(null);
    setPlanDetails({});
    setDialogState(() => ({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    }));

    const res = await deleteRiskManagementPlan(
      tabValue === 0 ? "cyberSecurity" : "supplyChain",
      tabValue === 0
        ? selectedRiskManagement?.csRiskManagementPlanID
        : selectedRiskManagement?.supplyChainPlanID,
      userId
    );
    // console.log("handleDeletePlan res", payload, res);
    if (res.succeeded === true) {
      setDialogState({
        title: "Success",
        body: "Plan successfully deleted",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }
  };

  const handleDownloadRiskManagementPlan = () => {
    if (isPlanSelected()) {
      console.log("Download");

      const res = downloadRiskManagementPlan(
        tabValue === 0,
        selectedRiskManagement,
        companyProfileID
      );
      // console.log("handleDownloadRiskManagementPlan res",selectedRiskManagement , res);
    }
  };

  const handleFetchPlanDetails = async () => {
    try {
      setIsLoadingPlanDetails(true);
      const res = await fetchRiskManagementPlanDetails(
        tabValue === 0 ? "cyberSecurity" : "supplyChain",
        tabValue === 0
          ? selectedRiskManagement?.csRiskManagementPlanID
          : selectedRiskManagement?.supplyChainPlanID
      );
      setPlanDetails(res);
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      setIsLoadingPlanDetails(false);
    }
  };

  useEffect(() => {
    if (!props.loadingPage && isPlanSelected()) {
      handleFetchPlanDetails();
    } else {
      setPlanDetails({});
    }
  }, [selectedRiskManagement]);

  return (
    <Fragment>
      <Grid sx={{ height: "100%", width: "100%" }}>
        <Grid display="flex" flexDirection="row" justifyContent="space-between">
          <Grid xs={6}>
            <Typography style={{ fontWeight: "400" }}>
              Plan Details ({selectedRiskManagement?.version})
            </Typography>
          </Grid>
          <Grid xs={6}>
            <Tooltip title="Create New Plan">
              <IconButton
                aria-label="add"
                onClick={() => displayRiskManagementForm("add")}
                disabled={!riskManagementPageAccess?.isCreate}
              >
                <PostAddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download Plan">
              <IconButton
                aria-label="download"
                onClick={handleDownloadRiskManagementPlan}
                disabled={
                  !isPlanSelected() || !riskManagementPageAccess?.isDownload
                }
              >
                {React.createElement(PlanImport, {
                  opacity:
                    !isPlanSelected() || !riskManagementPageAccess?.isDownload
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Plan">
              <IconButton
                aria-label="edit"
                onClick={handleEditRiskManagement}
                disabled={
                  !isPlanSelected() || !riskManagementPageAccess?.isUpdate
                }
              >
                {React.createElement(EditPlan, {
                  opacity:
                    !isPlanSelected() || !riskManagementPageAccess?.isUpdate
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Plan">
              <IconButton
                aria-label="delete"
                onClick={confirmDelete}
                disabled={
                  !isPlanSelected() || !riskManagementPageAccess?.isDelete
                }
              >
                {React.createElement(DeletePlan, {
                  opacity:
                    !isPlanSelected() || !riskManagementPageAccess?.isDelete
                      ? "50%"
                      : "100%",
                })}
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid>
          <h5
            style={{
              margin: "0.5rem 0",
              fontWeight: "400",
            }}
          >
            {isLoadingPlanDetails ? (
              <ListItem
                sx={{ width: "100%", display: "flex", flexDirection: "column" }}
              >
                <CircularProgress />
              </ListItem>
            ) : (
              <RichTextBoxTabPanel
                readonly={true}
                tabs={tabDetalis}
                handleTabEditerChange={() => {}}
              />
            )}
          </h5>
        </Grid>
      </Grid>
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleDialogClose}
        />
      }
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleDeletePlan}
          handleCancel={handleDialogClose}
        />
      }
    </Fragment>
  );
};
